export function toDotNotationUseFirstForArraysDeep(obj: any): any {
  const res: any = {};
  (function recurse(o?: any, current?: string) {
    for (const key in o) {
      const value = o[key];
      const newKey: string = current ? current + '.' + key : key; // joined key with dot
      if (Array.isArray(value)) {
        if (typeof value[0] === 'object') {
          recurse(value[0], newKey);
        } else {
          res[newKey] = value[0];
        }
      } else if (value && typeof value === 'object') {
        recurse(value, newKey); // it's a nested object, so do it again
      } else {
        res[newKey] = value; // it's not an object, so set the property
      }
    }
  })(obj);
  return res;
}

export function toDotNotationAggregateArraysDeep(obj: any): any {
  const res: any = {};
  (function recurse(o?: any, current?: string) {
    for (const key in o) {
      const value = o[key];
      const newKey: string = current ? current + '.' + key : key; // joined key with dot
      if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          if (typeof value[i] === 'object') {
            recurse(value[i], newKey);
          } else {
            if (!res[newKey]) {
              res[newKey] = [];
            }
            res[newKey].push(value[i]);
          }
        }
      } else if (value && typeof value === 'object') {
        recurse(value, newKey); // it's a nested object, so do it again
      } else {
        res[newKey] = value; // it's not an object, so set the property
      }
    }
  })(obj);
  return res;
}

export function toObjectFromDotNotation<T>(obj: any): T {
  const result: any = {};
  for (const i in obj) {
    const keys = i.split('.');
    keys.reduce((r: any, e: string, j: number) => {
      return (
        r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? (keys.length - 1 === j ? obj[i] : {}) : [])
      );
    }, result);
  }
  return result;
}

export function toKeyValuePairs(obj: any): { key: string; value: any; relevant: boolean }[] {
  return Object.keys(obj).map((key) => ({
    key,
    value: obj[key],
    relevant: key === 'id' || key === '_id',
  }));
}
